<app-loading-spinner *ngIf="isLoading"></app-loading-spinner>

<!-- Breadcrumb -->
<div
    class="flex flex-row items-center gap-5 font-semibold
           text-[#424242] dark:text-white mb-4 mr-5 ml-0">
    <p (click)="back()" class="cursor-pointer">Distribution Centres</p>
    <p>Assign Cities</p>
</div>

<!-- Filters -->
<div class="mx-auto p-6 bg-white dark:bg-[#363636] rounded-lg shadow-md">
    <h2 class="font-semibold dark:text-white">
        Assign Cities to Centre
    </h2>

    <div class="flex flex-row justify-between items-center gap-x-10 mt-4 px-10">
        <!-- Province Selector -->
        <div class="flex flex-col w-2/5">
            <label for="province" class="dark:text-white mb-1">
                Province
            </label>

            <div class="relative rounded-lg flex-shrink-0">
                <app-searchable-dropdown
                    id="province"
                    name="province"
                    [items]="provinceItems"
                    [placeholder]="'--Select Province--'"
                    [searchPlaceholder]="'Search provinces...'"
                    [(ngModel)]="selectProvince"
                    #provinceInput="ngModel"
                    (ngModelChange)="filterProvince($event)">
                </app-searchable-dropdown>
            </div>
        </div>

        <!-- District Selector -->
        <div class="flex flex-col w-2/5">
            <label for="district" class="dark:text-white mb-1">
                District
            </label>

            <div class="relative rounded-lg flex-shrink-0">
                <app-searchable-dropdown
                    id="district"
                    name="district"
                    [items]="districtItems"
                    [placeholder]="'--Select District--'"
                    [searchPlaceholder]="'Search districts...'"
                    [(ngModel)]="selectDistrict"
                    #districtInput="ngModel"
                    (ngModelChange)="filterDistrict($event)">
                </app-searchable-dropdown>
            </div>
        </div>

        <!-- Go Button -->
        <div class="w-1/5 self-end">
            <button
                type="button"
                (click)="fetchData()"
                [disabled]="!selectProvince || !selectDistrict"
                class="bg-[#415CFF] text-white text-lg px-4 py-2 rounded-md
                       disabled:opacity-50 disabled:cursor-not-allowed">
                Go
            </button>
        </div>
    </div>
</div>

<div class="h-[20px]"></div>

<!-- Table -->
<div class="mx-auto p-6 bg-white dark:bg-[#363636] rounded-lg shadow-md">

    <!-- Both horizontal and vertical scrolling happen inside this container -->
    <div
        *ngIf="hasData"
        class="relative max-h-[500px] overflow-auto">

        <table class="min-w-full border-separate border-spacing-0 table-auto">
            <thead>
                <tr>
                    <!-- Fixed in both directions -->
                    <th
                        scope="col"
                        class="sticky top-0 left-0 z-30 min-w-[180px]
                               bg-white dark:bg-[#363636]
                               px-4 py-3 font-normal text-left whitespace-nowrap
                               text-textLight dark:text-textDark
                               border-b border-gray-200 dark:border-gray-600">
                        City
                    </th>

                    <!-- Fixed vertically; scrolls horizontally -->
                    <th
                        *ngFor="let center of centersArr"
                        scope="col"
                        class="sticky top-0 z-20 min-w-[120px]
                               bg-white dark:bg-[#363636]
                               px-4 py-3 font-normal text-center whitespace-nowrap
                               text-textLight dark:text-textDark
                               border-b border-gray-200 dark:border-gray-600">
                        {{ center.regCode }}
                    </th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let city of citiesArr">
                    <!-- Fixed horizontally; scrolls vertically -->
                    <td
                        class="sticky left-0 z-10 min-w-[180px]
                               bg-white dark:bg-[#363636]
                               px-4 py-3 text-left whitespace-nowrap
                               text-textLight dark:text-textDark
                               border-b border-gray-200 dark:border-gray-600">
                        {{ city.city }}
                    </td>

                    <!-- Scrollable assignment cells -->
                    <td
                        *ngFor="let center of centersArr"
                        class="min-w-[120px] px-4 py-3 text-center
                               border-b border-gray-200 dark:border-gray-600">

                        <label class="inline-flex items-center cursor-pointer">
                            <input
                                type="checkbox"
                                [checked]="isCityAssignedToCenter(city.id, center.id)"
                                (change)="toggleAssignment(city.id, center.id, $event)"
                                [disabled]="isToggleDisabled(city.id, center.id)"
                                [attr.aria-label]="'Assign ' + city.city + ' to ' + center.regCode"
                                class="sr-only peer">

                            <div
                                class="relative w-11 h-6 bg-gray-200
                                       peer-focus:outline-none peer-focus:ring-4
                                       peer-focus:ring-blue-300
                                       dark:peer-focus:ring-blue-800
                                       rounded-full peer dark:bg-gray-700
                                       peer-checked:after:translate-x-full
                                       rtl:peer-checked:after:-translate-x-full
                                       peer-checked:after:border-white
                                       after:content-[''] after:absolute
                                       after:top-[2px] after:start-[2px]
                                       after:bg-white after:border-gray-300
                                       after:border after:rounded-full
                                       after:h-5 after:w-5 after:transition-all
                                       dark:border-gray-600
                                       peer-checked:bg-blue-600
                                       dark:peer-checked:bg-blue-600
                                       peer-disabled:opacity-50
                                       peer-disabled:cursor-not-allowed">
                            </div>
                        </label>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- Before Fetching -->
    <div
        *ngIf="!fetched"
        class="flex flex-col items-center w-full h-screen px-10 py-7 mt-6">
        <p class="text-[#494949] my-6 dark:text-textDark">
            --Please select the province and district first--
        </p>

        <img
            src="assets/images/NoData.png"
            alt="No Data"
            class="w-20 h-20" />
    </div>

    <!-- No Centres Found -->
    <div
        *ngIf="!hasData && fetched"
        class="flex flex-col items-center w-full h-screen px-10 py-7 mt-6">
        <p class="text-[#494949] my-6 dark:text-textDark">
            --No Centres in this district--
        </p>

        <img
            src="assets/images/NoData.png"
            alt="No Data"
            class="w-20 h-20" />
    </div>
</div>